import { FunctionComponent } from 'react';

const Title: FunctionComponent<{ title: string; isCenter?: boolean }> = ({
  title,
  isCenter = true,
}) => {
  return (
    <>
      {isCenter ? (
        <h2 className="text-2xl my-5 mx-5 text-center font-bold">{title}</h2>
      ) : (
        <h2 className="text-2xl my-5 mx-5 font-bold">{title}</h2>
      )}
    </>
  );
};

export default Title;
